"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var umi_request_1 = require("umi-request");
var next_1 = require("@alifd/next");
var urlParse = require("url-parse");
var qs = require("querystringify");
var f_1 = require("./f");
var PORTAL_PREFEX = "/newHall";
var request = umi_request_1.extend({
    timeout: 20 * 1000,
    errorHandler: function (error) {
        console.error(error);
        next_1.Message.error("抱歉，网络异常，请稍后再试。");
    },
});
var startTime = 0;
var apiPath = "";
var sequenceNo = "";
request.interceptors.request.use(function (url, options) {
    startTime = Date.now();
    options.credentials = "include";
    var urlObj = new urlParse(url);
    apiPath = urlObj.pathname;
    var query = qs.parse(urlObj.query);
    sequenceNo = query.sequenceNo;
    if (options &&
        options.method &&
        options.method.toLocaleLowerCase() === "get") {
        var flag = "?";
        if (url.indexOf("?") > -1) {
            flag = "&";
        }
        url = url + flag + "t=" + Date.now();
    }
    return {
        url: url,
        options: __assign({}, options),
    };
});
var f = function (params) {
    try {
        var url = params.url, rest = __rest(params, ["url"]);
        // 用户中心要求uc 开头的url 需要增加请求头
        if (url.indexOf("/uc/") !== -1) {
            rest.headers = __assign({}, rest.headers, { channel: "pc" }, f_1.deviceFactor());
        }
        else {
            rest.headers = __assign({}, rest.headers, { channel: "pc" });
        }
        return request(url, rest);
    }
    catch (e) {
        return Promise.resolve({});
    }
};
exports.default = f;
